/** Shared dashboard Create New launch: picker → registry wizard → detail page. */

import { canonicalFormType, FORM_TYPE_CATALOG } from './formTypeIds';

const CORE_DASHBOARD_FORM_TYPES = new Set(FORM_TYPE_CATALOG.map((entry) => entry.formType));

export function returnToCatalogPicker(formType) {
  return {
    showCreateModal: true,
    startOnOther: !CORE_DASHBOARD_FORM_TYPES.has(canonicalFormType(formType)),
    dashboardFormType: null,
    createdResult: null,
  };
}

export function createNewClickIntent(
  isTransactionGuest,
  canGenerateForms = true,
  formGenerationPlanBlocked = false,
) {
  if (isTransactionGuest) return 'upgrade';
  if (formGenerationPlanBlocked && !canGenerateForms) return 'form-upgrade';
  if (!canGenerateForms) return 'plans';
  return 'picker';
}

export function startDashboardForm(formType) {
  return {
    showCreateModal: false,
    dashboardFormType: formType,
    createdResult: null,
  };
}

export function purchaseAgreementCloseResult(submitResult) {
  if (!submitResult?.success) return undefined;
  return { contractId: submitResult.data?.contract_id ?? null };
}

export function resolveDashboardFormClose({
  spec,
  result,
  storedResult,
  isAuthenticated,
}) {
  const entityId = (
    spec?.entityIdFromResult?.(result)
    || spec?.entityIdFromResult?.(storedResult)
    || null
  );
  if (entityId && spec.detailPath) {
    return { action: 'navigate', path: spec.detailPath(entityId, result || storedResult) };
  }
  if (!isAuthenticated || !spec) {
    return { action: 'idle' };
  }
  return { action: 'refresh', refresh: spec.refresh };
}

export function buildPortalCreateSubmit(spec, { baseUrl, userEmail, post }) {
  if (!spec?.portalCreatePath) return undefined;
  return async (payload) => {
    const res = await post(`${baseUrl}${spec.portalCreatePath}`, {
      user_email: userEmail,
      ...payload,
    });
    return res.data;
  };
}
